import {
  getDayFieldVisibility,
  getInventoryFieldVisibility,
  getSpecialFieldVisibility,
} from "./Toolbar/utils";

export const salesTrackingStoreSlice = (set) => ({
  stShowAlert: true,
  stCurrency: "local",
  stStock: null,
  stSelectedMarketplace: 1,
  stSelectedBrand: null,
  stSelectedCategoryPath: null,
  stOwners: [],
  stSelectedOwners: [],
  stDomains: [],
  stSelectedDomains: [],
  stLifeCycle: [],
  stSearch: [],
  stSelectedCells: [],
  stHitoMarkActive: false,
  stSelectedHitoCells: [],
  stShowCards: true,
  stShowHotProducts: false,
  stProjectedTarget: false,
  stDayCurrentPin: true,
  stShowedColumns: INITIAL_COLUMNS_STATE,
  stShowedCellRows: INITIAL_ROW_CELLS_STATE,
  stPinnedColumns: INITIAL_PINNED_COLUMNS,
  stKams: [],
  stSelectedKams: [],

  setStShowAlert: (showAlert) => set(() => ({ stShowAlert: showAlert })),
  showStLocalCurrency: () => set(() => ({ stCurrency: "local" })),
  showStUsdCurrency: () => set(() => ({ stCurrency: "usd" })),
  showStWithStock: () => set(() => ({ stStock: "stock" })),
  showStWithoutStock: () => set(() => ({ stStock: "no stock" })),
  showStAllStock: () => set(() => ({ stStock: null })),
  setStSelectedBrand: (brand) =>
    set((state) => {
      const newBrand = state.stSelectedBrand === brand ? null : brand;
      return { stSelectedBrand: newBrand };
    }),
  resetStSelectedBrand: () => set(() => ({ stSelectedBrand: null })),
  setStSelectedCategoryPath: (categoryPath) =>
    set((state) => {
      const newCategoryPath =
        state.stSelectedCategoryPath === categoryPath ? null : categoryPath;
      return { stSelectedCategoryPath: newCategoryPath };
    }),
  clearStSelectedCategoryPath: () =>
    set(() => ({ stSelectedCategoryPath: null })),
  setStSelectedMarketplace: (selectedMarketplace) =>
    set((state) => {
      const newState = { stSelectedMarketplace: selectedMarketplace };

      let newUxValue;
      if (selectedMarketplace !== 1) {
        newUxValue = false;
      } else if (selectedMarketplace === 1) {
        newUxValue = true;
      } else {
        newUxValue = state.stShowedCellRows.ux;
      }
      if (newUxValue !== state.stShowedCellRows.ux) {
        newState.stShowedCellRows = {
          ...state.stShowedCellRows,
          ux: newUxValue,
        };
      }

      return newState;
    }),
  resetStSelectedMarketplace: () => set(() => ({ stSelectedMarketplace: 1 })),
  setStOwners: (owners) => set(() => ({ stOwners: owners })),
  toggleStSelectedOwners: (owner) =>
    set((state) => ({
      stSelectedOwners: state.stSelectedOwners.includes(owner)
        ? state.stSelectedOwners.filter((item) => item !== owner)
        : [...state.stSelectedOwners, owner],
    })),
  clearStSelectedOwners: () => set(() => ({ stSelectedOwners: [] })),
  setStDomains: (domains) => set(() => ({ stDomains: domains })),
  toggleStSelectedDomains: (domain) =>
    set((state) => ({
      stSelectedDomains: state.stSelectedDomains.includes(domain)
        ? state.stSelectedDomains.filter((item) => item !== domain)
        : [...state.stSelectedDomains, domain],
    })),
  setSelectedDomains: (domains) =>
    set(() => ({ stSelectedDomains: [domains] })),
  clearStSelectedDomains: () => set(() => ({ stSelectedDomains: [] })),
  toggleStLifeCycle: (lifeCycle) =>
    set((state) => ({
      stLifeCycle: state.stLifeCycle.includes(lifeCycle)
        ? state.stLifeCycle.filter((item) => item !== lifeCycle)
        : [...state.stLifeCycle, lifeCycle],
    })),
  clearStLifeCycle: () => set(() => ({ stLifeCycle: [] })),
  setStSearch: (newSearch) =>
    set((state) => {
      const current = state.stSearch || [];

      // Convertir siempre a array
      const incoming = Array.isArray(newSearch) ? newSearch : [newSearch];

      // Filtrar vacíos y duplicados
      const cleaned = incoming
        .map((x) => x?.trim())
        .filter((x) => x && !current.includes(x));

      return { stSearch: [...current, ...cleaned] };
    }),
  deleteStSearch: (sku) =>
    set((state) => ({
      stSearch: state.stSearch.filter((s) => s !== sku),
    })),
  toggleStSelectedCells: (selectedCell) =>
    set((state) => {
      if (
        state.stSelectedCells.length > 0 &&
        state.stSelectedCells?.[0]?.sku !== selectedCell?.sku
      ) {
        return {
          alertState: {
            open: true,
            message:
              "Solo se puede marcar celdas del mismo SKU. Has seleccionado celdas de diferentes filas. Corrige tu selección.",
            title: "Selecciona celdas de un mismo SKU",
            severity: "warning",
          },
        };
      }

      const isSelected = state.stSelectedCells.find(
        (p) => p.fecha === selectedCell?.fecha && p.sku === selectedCell?.sku,
      );

      if (isSelected) {
        return {
          stSelectedCells: state.stSelectedCells.filter(
            (p) =>
              p.fecha !== selectedCell?.fecha || p.sku !== selectedCell?.sku,
          ),
        };
      }

      return {
        stSelectedCells: [...state.stSelectedCells, selectedCell],
      };
    }),
  clearStSelectedSku: () => set(() => ({ stSearch: [] })),
  toggleStSelectedSku: (sku) =>
    set((state) => ({
      stSearch: state.stSearch.includes(sku)
        ? state.stSearch.filter((s) => s !== sku)
        : [...state.stSearch, sku],
    })),
  clearStSelectedCells: () => set(() => ({ stSelectedCells: [] })),
  setStHitoMarkActive: (active) => set(() => ({ stHitoMarkActive: active })),
  toggleStSelectedHitoCells: (selectedHitoCell) =>
    set((state) => {
      if (
        state.stSelectedHitoCells.length > 0 &&
        state.stSelectedHitoCells?.[0]?.sku !== selectedHitoCell?.sku
      ) {
        return {
          alertState: {
            open: true,
            message:
              "Solo se puede marcar hito con celdas del mismo SKU. Has seleccionado celdas de diferentes filas. Corrige tu selección.",
            title: "Selecciona celdas de un mismo SKU",
            severity: "warning",
          },
        };
      }

      const isSelected = state.stSelectedHitoCells.find(
        (p) =>
          p.fecha === selectedHitoCell?.fecha &&
          p.sku === selectedHitoCell?.sku,
      );

      if (isSelected) {
        return {
          stSelectedHitoCells: state.stSelectedHitoCells.filter(
            (p) =>
              p.fecha !== selectedHitoCell?.fecha ||
              p.sku !== selectedHitoCell?.sku,
          ),
        };
      }

      return {
        stSelectedHitoCells: [...state.stSelectedHitoCells, selectedHitoCell],
      };
    }),
  clearStSelectedHitoCells: () => set(() => ({ stSelectedHitoCells: [] })),
  toggleStShowCards: () =>
    set((state) => ({ stShowCards: !state.stShowCards })),
  toggleStShowHotProducts: () =>
    set((state) => ({ stShowHotProducts: !state.stShowHotProducts })),
  changeStShowedColumns: (monthToChange, show) =>
    set((state) => {
      const selectedGroups = {
        inventory: state.stShowedColumns.fulfillment,
        formerMonth:
          state.stShowedColumns["former_month-1"] &&
          state.stShowedColumns["former_month-acc"],
        formerDaily: state.stShowedColumns["former_month-1"],
        formerTotal: state.stShowedColumns["former_month-acc"],
        currentMonth:
          state.stShowedColumns["current_month-1"] &&
          state.stShowedColumns["current_month-acc"],
        currentDaily: state.stShowedColumns["current_month-1"],
        currentTotal: state.stShowedColumns["current_month-acc"],
      };

      if (monthToChange === "formerMonth") {
        selectedGroups.formerDaily = show;
        selectedGroups.formerTotal = show;
      }

      if (monthToChange === "currentMonth") {
        selectedGroups.currentDaily = show;
        selectedGroups.currentTotal = show;
      }

      if (
        (monthToChange === "formerDaily" || monthToChange === "formerTotal") &&
        show
      ) {
        selectedGroups.formerMonth = true;
      }

      if (
        (monthToChange === "currentDaily" ||
          monthToChange === "currentTotal") &&
        show
      ) {
        selectedGroups.currentMonth = true;
      }

      if (
        ((monthToChange === "formerDaily" && !selectedGroups.formerTotal) ||
          (monthToChange === "formerTotal" && !selectedGroups.formerDaily)) &&
        !show
      ) {
        selectedGroups.formerMonth = false;
      }

      if (
        ((monthToChange === "currentDaily" && !selectedGroups.currentTotal) ||
          (monthToChange === "currentTotal" && !selectedGroups.currentDaily)) &&
        !show
      ) {
        selectedGroups.currentMonth = false;
      }

      selectedGroups[monthToChange] = show;

      const result = {
        ...state.stShowedColumns,
        ...getInventoryFieldVisibility({ show: selectedGroups.inventory }),
        ...getDayFieldVisibility({
          month: "former_month",
          show: selectedGroups.formerDaily,
        }),
        ...getSpecialFieldVisibility({
          month: "former_month",
          show: selectedGroups.formerTotal,
        }),
        ...getDayFieldVisibility({
          month: "current_month",
          show: selectedGroups.currentDaily,
        }),
        ...getSpecialFieldVisibility({
          month: "current_month",
          show: selectedGroups.currentTotal,
        }),
      };

      return {
        stShowedColumns: result,
      };
    }),
  resetStShowedColumns: () =>
    set(() => ({
      stShowedColumns: INITIAL_COLUMNS_STATE,
    })),

  stClearFilters: () =>
    set(() => ({
      // stSelectedBrand: null,
      // stSelectedCategoryPath: null,
      // stSelectedOwners: [],
      stSelectedDomains: [],
      // stLifeCycle: [],
      // stStock: null,
      // stSearch: '',
      // stSelectedCells: [],
      // stSelectedHitoCells: [],
      stSelectedMarketplace: 1,
      stShowedCellRows: INITIAL_ROW_CELLS_STATE,
      stDayCurrentPin: true,
    })),
  changeStVisibleCellRows: (cellName, value) =>
    set((state) => {
      const rows = { ...state.stShowedCellRows };

      rows[cellName] = value;

      return { stShowedCellRows: rows };
    }),
  resetStVisibleCellRows: () =>
    set((state) => {
      const selectedMarketplace = state.stSelectedMarketplace;
      let newUxValue;

      if (selectedMarketplace === 1) {
        newUxValue = true;
      } else {
        newUxValue = false;
      }

      const newShowedCellRows = {
        ...INITIAL_ROW_CELLS_STATE,
        ux: newUxValue,
      };

      return {
        stShowedCellRows: newShowedCellRows,
      };
    }),
  changeStPinnedColumns: (columnName, value) =>
    set((state) => {
      let isFormerPinned =
        state.stPinnedColumns.right.includes("former_month-acc");

      let isCurrentPinned =
        state.stPinnedColumns.right.includes("current_month-acc");

      if (columnName === "formerMonth") {
        isFormerPinned = value;
      } else {
        isCurrentPinned = value;
      }

      const columnsToPin = [];
      if (isFormerPinned) {
        columnsToPin.push(
          ...["former_month-acc", "former_month-forecast", "former_month-gap"],
        );
      }

      if (isCurrentPinned) {
        columnsToPin.push(
          ...[
            "current_month-acc",
            "current_month-forecast",
            "current_month-proyectado",
            "current_month-gap",
          ],
        );
      }

      return {
        stPinnedColumns: {
          ...state.stPinnedColumns,

          right: columnsToPin,
        },
      };
    }),
  resetStDayCurrentPin: () =>
    set(() => ({
      stDayCurrentPin: true,
    })),
  toggleStDayCurrentPin: () => {
    set((state) => {
      return {
        stDayCurrentPin: !state.stDayCurrentPin,
      };
    });
  },
  resetStPinnedColumns: () =>
    set(() => ({
      stPinnedColumns: INITIAL_PINNED_COLUMNS,
    })),
  toggleProjectedTarget: () =>
    set((state) => ({
      stProjectedTarget: !state.stProjectedTarget,
    })),
  setStKams: (kams) => set(() => ({ stKams: kams })),
  setStSelectedKams: (kams) => set(() => ({ stSelectedKams: kams })),
  toggleSelectedKams: (kam) =>
    set((state) => {
      const selectedKams = state.stSelectedKams;
      const isSelected = selectedKams.includes(kam);

      if (isSelected) {
        return {
          stSelectedKams: selectedKams.filter((k) => k !== kam),
        };
      } else {
        return {
          stSelectedKams: [...selectedKams, kam],
        };
      }
    }),
  clearStSelectedKams: () => set(() => ({ stSelectedKams: [] })),
});

export const INITIAL_COLUMNS_STATE = {
  __detail_panel_toggle__: true,
  thumbnail: true,
  sku: true,
  category_owner: true,
  ...getInventoryFieldVisibility({ show: true }),
  info: true,
  ...getDayFieldVisibility({ month: "former_month", show: true }),
  ...getSpecialFieldVisibility({ month: "former_month", show: true }),

  ...getDayFieldVisibility({ month: "current_month", show: true }),
  ...getSpecialFieldVisibility({ month: "current_month", show: true }),
};

export const INITIAL_ROW_CELLS_STATE = {
  target: true,
  tsu: true,
  GMV: true,
  visits: true,
  ASP: true,
  mg: true,
  CVR: true,
  stock: false,
  roas: true,
  mc2: true,
  ux: true,
};

export const INITIAL_PINNED_COLUMNS = {
  left: [
    "__detail_panel_toggle__",
    "item_id",
    "thumbnail",
    "sku",
    "category_owner",
    "npi",
    "deposit",
    "fulfillment",
    "days",
    "stock",
    "stock_no_disponible",
    "velocidad_rotacion",
    "dias_stock",
    "info",
  ],
  right: [
    "current_month-acc",
    "current_month-forecast",
    "current_month-proyectado",
    "current_month-gap",
  ],
};
